import { SelectorMap } from 'ia-react-core/~/interfaces/ReducerSelectors';
import validSelector from '../../../selectors/form/validSelector';
import isValidSelector from '../../../selectors/form/isValidSelector';
import isDirtySelector from '../../../selectors/form/isDirtySelector';
import isDeeplyValidSelector from '../../../selectors/form/isDeeplyValidSelector';
import isDeeplyDirtySelector from '../../../selectors/form/isDeeplyDirtySelector';
import isDeeplySubmittingSelector from '../../../selectors/form/isDeeplySubmittingSelector';
import isDeeplyValidatingSelector from '../../../selectors/form/isDeeplyValidatingSelector';

const formSelectors = {
  valid: validSelector,
  isValid: isValidSelector,
  isDirty: isDirtySelector,
  isDeeplyValid: isDeeplyValidSelector,
  isDeeplyDirty: isDeeplyDirtySelector,
  isDeeplySubmitting: isDeeplySubmittingSelector,
  isDeeplyValidating: isDeeplyValidatingSelector,
} as SelectorMap;

export default formSelectors;
